module.exports = __webpack_public_path__ + "static/media/icons_Les Essentiels - bilan genou.71c79084.svg";